import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-step-company-social-mautic',
  templateUrl: './step-company-social-mautic.component.html',
  styleUrls: ['./step-company-social-mautic.component.scss']
})
export class StepCompanySocialMauticComponent implements OnInit {

  formData: any = {};
  @ViewChild('form2', { static: false }) form: ElementRef<any>;

  constructor(
    router: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public formApiUrl: string
  ) {

      router.queryParams.subscribe(
        query => {
            
            this.formData = query;
            setTimeout(() => this.form.nativeElement.submit(), 500);
            
        }
      )

  }

  ngOnInit(): void {
  }

}
